module.exports = __webpack_public_path__ + "images/404.1788405320306.png";